import React, { useState, useEffect } from "react";
import "../css/KuyumcuLeftSideNavbar.css";
// import PremiumBackground from "./PremiumBackground";
import logo from "../../../img/logo-kucuk-gold.jpeg";
import { useNavigate } from "react-router-dom";
import {
  FaBars,
  FaCashRegister,
  FaUser,
  FaUsers,
  FaSignOutAlt,
  FaBoxOpen,
  FaChartPie,
  FaArchive,
  FaHistory,
  FaShoppingBag,
  FaSuitcase,
  FaBoxes,
  FaWarehouse,
  FaCubes,
  FaSlidersH,
  FaUserShield,
} from "react-icons/fa";
import elma from "../../../img/elma.png";
import ProsetLogo from "../../../img/logo-kucuk-gold.jpeg";
import { MdQrCodeScanner } from "react-icons/md";
import axiosInstance from "../../../api/axiosInstance";

const KuyumcuLeftSideNavbar = ({ onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [yetkiler, setYetkiler] = useState([]);

  const navigate = useNavigate();

  const userId =
    localStorage.getItem("userId") || sessionStorage.getItem("userId");

  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    localStorage.removeItem("userId");
    sessionStorage.removeItem("userId");
    localStorage.removeItem("uyelikTip");
    sessionStorage.removeItem("uyelikTip");
    localStorage.removeItem("kuyumcuTipi");
    sessionStorage.removeItem("kuyumcuTipi");
    navigate("/");
  };

  // Açılan Menülerin state'i
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = () => {
    const newState = !isOpen;
    setIsOpen(newState);

    if (newState) document.body.classList.add("sidebar-open");
    else document.body.classList.remove("sidebar-open");
  };

  const toggleDropdown = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigate = (target) => {
    setIsOpen(false);
    document.body.classList.remove("sidebar-open");
    if (onNavigate) onNavigate(target);
  };

  const uyelikTip =
    localStorage.getItem("uyelikTip") || sessionStorage.getItem("uyelikTip");

  const kuyumcuTipi =
    localStorage.getItem("kuyumcuTipi") || sessionStorage.getItem("kuyumcuTipi");

  const uyelikTipi =
    localStorage.getItem("uyelikTip") || sessionStorage.getItem("uyelikTip");

  const yetkiSet = new Set(yetkiler || []);

  const hasPermission = (code) => {
    if (yetkiSet.has("ALL")) return true;
    return yetkiSet.has(code);
  };

  const loadYetkiler = async () => {
    if (!userId) return;

    try {
      const resp = await axiosInstance.get("/me/yetki-kodlari", {
        params: { girisYapanUserId: userId },
      });
      setYetkiler(resp.data || []);
    } catch (e) {
      console.error("Navbar yetkileri alınamadı:", e);
      setYetkiler([]);
    }
  };

  useEffect(() => {
    if (!userId) return;
    loadYetkiler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const barkodMenuGorunsun =
    uyelikTipi === "SUPER_USER" ||
    (
      uyelikTipi === "KUYUMCU" &&
      kuyumcuTipi === "VITRIN_KUYUMCU"
    ) ||
    (
      uyelikTipi !== "KUYUMCU" &&
      hasPermission("BARKODLU_ISLEMLER_VIEW")
    );

  return (
    <>
      <div className="hamburger-btn" onClick={toggleMenu}>
        <FaBars size={22} />
      </div>

      <div
        className={`sidebar ${isOpen ? "open" : ""} ${
          isMobile ? "mobile" : ""
        }`}
      >
{/*         <PremiumBackground /> */}

        <div className="sidebar-header">
          <div
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcu");
            }}
            className="logo-circle"
          >
            <img className="logo-elma" src={ProsetLogo} alt="logo" />
          </div>
        </div>

        {/* Menü Yapısı */}
        <ul className="sidebar-links">

          {/* 1) Yönetim Paneli */}
          {uyelikTip === "SUPER_USER" && (
            <li
              onClick={() => {
                setIsOpen(false);
                document.body.classList.remove("sidebar-open");
                navigate("/kuyumcuYonetimPanel");
              }}
            >
              <FaUserShield />
              <span>Yönetim Paneli</span>
            </li>
          )}

          {/* 1) BARKODLU İŞLEMLER */}
          {barkodMenuGorunsun && (
            <li
              onClick={() => {
                setIsOpen(false);
                document.body.classList.remove("sidebar-open");
                navigate("/kuyumcuBarkodluIslemler");
              }}
            >
              <MdQrCodeScanner />
              <span>Barkodlu İşlemler</span>
            </li>
          )}

          {/* 1) HESAPLAR */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuHesaplar");
            }}
          >
            <FaUser />
            <span>Hesaplar</span>
          </li>

          {/* 2) KASA */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuKasa");
            }}
          >
            <FaCashRegister />
            <span>Kasa</span>
          </li>

          {/* 3) STOK */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuStok");
            }}
          >
            <FaCubes />
            <span>Stok</span>
          </li>

          {/* 4) ÇANTA */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuCanta");
            }}
          >
            <FaShoppingBag />
            <span>Çanta</span>
          </li>

          {/* 5) RAPORLAR */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuRaporlar");
            }}
          >
            <FaChartPie />
            <span>Raporlar</span>
          </li>


          {/* İşlem Geçmişi */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuIslemGecmisi");
            }}
          >
            <FaHistory />
            <span>İşlem Geçmişi</span>
          </li>

          {/* PARAMETRELER */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuParametreler");
            }}
          >
            <FaSlidersH />
            <span>Parametreler</span>
          </li>

          {/* KULLANICILAR */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuKullanicilar");
            }}
          >
            <FaUsers />
            <span>Kullanıcılar</span>
          </li>

          {/* PROFIL */}
          <li
            onClick={() => {
              setIsOpen(false);
              document.body.classList.remove("sidebar-open");
              navigate("/kuyumcuProfil");
            }}
          >
            <FaUser />
            <span>Profil</span>
          </li>

        </ul>

        {/* Footer */}
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <FaSignOutAlt /> <span>Çıkış Yap</span>
          </button>
        </div>
      </div>

      {/* Mobil overlay */}
      {isMobile && isOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </>
  );
};

export default KuyumcuLeftSideNavbar;